var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58172 0 8V22C0 26.4183 3.58172 30 8 30H22C26.4183 30 30 26.4183 30 22V8C30 3.58172 26.4183 0 22 0H8ZM21.9421 8.21224L20.9607 7.82086L15.8895 13.239L12.1138 8.17283L9.46634 8.15957L7.6331 8.15038L8.72828 9.62056L13.4151 15.9121L7.51245 22.2202L8.50901 22.5722L14.0115 16.7128L17.9964 22.0622H20.6384H22.4651L21.3736 20.5975L16.4775 14.028L21.9421 8.21224ZM10.5615 9.62975L18.7317 20.5975H19.5469L11.376 9.63383L10.5615 9.62975Z",
    fill: "#383765"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2402795862cb9c20446f9c621797eb71.svg";
export { ForwardRef as ReactComponent };